import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Portfolio from "./Portfolio";
import ProjectList from "./ProjectList";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Portfolio />}></Route>
                <Route path="/projects" element={<ProjectList />}></Route>
            </Routes>
        </Router>
    );
}

export default App;
